import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OtdSipToggleComponent } from './otd-sip-toggle.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';



@NgModule({
  declarations: [
    OtdSipToggleComponent
  ],
  imports: [
    CommonModule,
    MatSlideToggleModule
  ],
  exports: [OtdSipToggleComponent],
  bootstrap: [OtdSipToggleComponent]
})
export class OtdSipToggleModule { }
